export interface IAccountMenuItem {
	key: string
	translationKey: string
	icon: string
	type: 'tab' | 'link' | 'external'
	to?: string
	hrefPl?: string
	hrefEn?: string
}

export const accountMenuItems: IAccountMenuItem[] = [
	{
		key: 'start_booking',
		translationKey: 'start_booking',
		icon: 'car',
		type: 'link',
		to: 'cars',
	},
	{
		key: 'overview',
		translationKey: 'overview',
		icon: 'avatar',
		type: 'tab',
		to: 'account',
	},
	{
		key: 'orders',
		translationKey: 'orders',
		icon: 'ticket',
		type: 'tab',
		to: 'account-orders',
	},
	{
		key: 'data',
		translationKey: 'change_data',
		icon: 'profile',
		type: 'tab',
		to: 'account-data',
	},
	{
		key: 'password',
		translationKey: 'change_password',
		icon: 'shield-tick',
		type: 'tab',
		to: 'account-password',
	},
	{
		key: 'notifications',
		translationKey: 'notifications',
		icon: 'message-text',
		type: 'tab',
		to: 'account-notifications',
	},
	{
		key: 'language',
		translationKey: 'change_language',
		icon: 'earth',
		type: 'tab',
		to: 'account-language',
	},
	{
		key: 'contact',
		translationKey: 'contact',
		icon: 'call-outline',
		type: 'link',
		to: 'contact',
	},
	{
		key: 'privacy_policy',
		translationKey: 'privacy_policy',
		icon: 'note-text',
		type: 'link',
		to: 'privacy-policy',
	},
	{
		key: 'rental_terms',
		translationKey: 'rental_terms',
		icon: 'note-text',
		type: 'link',
		to: 'general-terms-and-conditions',
	},
]
